export function parseUrlPath(input = '') {
  const [pathname = '', search = '', hash = ''] = (
    input.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []
  ).splice(1)

  return {
    pathname,
    search,
    hash,
  }
}
